module.exports = __webpack_public_path__ + "static/media/Nosepass_gaussian2.c4282da6.png";